import { useEffect, useState } from 'react';

import { DesignThinkingWhyPayload } from '../types';
import { fetchDesignThinkingWhy } from '../services/designThinkingService';
import { API_ENDPOINTS } from '../constants/api';

export const useDesignThinkingWhy = () => {
  const [designThinkingWhy, setDesignThinkingWhy] = useState<DesignThinkingWhyPayload | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadDesignThinkingWhy = async () => {
      try {
        setLoading(true);
        console.log('Fetching from:', API_ENDPOINTS.designThinkingWhy);
        const data = await fetchDesignThinkingWhy();
        console.log('API response:', data);
        if (isMounted) {
          setDesignThinkingWhy(data);
          setError(null);
        }
      } catch (error) {
        console.error('Failed to load design thinking why content', error);
        if (isMounted) {
          setError(error instanceof Error ? error.message : 'Unknown error occurred');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadDesignThinkingWhy();

    return () => {
      isMounted = false;
    };
  }, []);

  return { designThinkingWhy, loading, error };
};
